import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PrivateRoute from "../framework/private-route";

/** Import pages */
import { DashboardPage } from "../pages/dashboard-page";
import { LoginPage } from "../pages/account/login-page";
import { ResetPasswordPage } from "../pages/account/reset-password-page";
import { MaterialsPage } from "../pages/materials/materials-page";
import { ProgramsPage } from "../pages/programs/programs-page";
import { AssessmentsPage } from "../pages/assessments/assessments-page";
import { TextMessagesPage } from "../pages/textMessages/text-messages-page.js";
import { TermsOfUse } from "../pages/termsOfUse/terms-of-use.js";
import { TermsOfUsePublic } from "../pages/termsOfUse/terms-of-use-public.js";
import { VerificationPage } from "../pages/verification/verification-page";
import { MobileCapturePage } from "../pages/verification/mobile-capture-page";
import { VerifyEmailPage } from "../pages/verification/verify-email-page";
import { VerifyMobilePage } from "../pages/verification/verify-mobile-page";

export const RootRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route exact path="/login" element={<LoginPage />} />
        <Route exact path="/mobile-capture" element={<MobileCapturePage />} />
        <Route
          exact
          path="/password-update/:email/:guid/:lang"
          element={<ResetPasswordPage />}
        />
        <Route exact path="/termsOfUse" element={<TermsOfUsePublic />} />
        <Route exact path="/verify/:id/:hash" element={<VerifyEmailPage />} />
        <Route exact path="/verify-mobile/:id/:hash" element={<VerifyMobilePage />} />

        {/* PRIVATE ROUTES */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/materials" element={<MaterialsPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/assessments" element={<AssessmentsPage />} />
          <Route path="/textMessages" element={<TextMessagesPage />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/verification" element={<VerificationPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
